import { render, staticRenderFns } from "./WordTest.vue?vue&type=template&id=9edb0b5e&scoped=true&"
import script from "./WordTest.vue?vue&type=script&lang=js&"
export * from "./WordTest.vue?vue&type=script&lang=js&"
import style0 from "./WordTest.vue?vue&type=style&index=0&id=9edb0b5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edb0b5e",
  null
  
)

export default component.exports